import React from 'react';

import { Patient } from '../../types';
import { Container, Text, Link } from './ScheduleCTA.styled';
import { useTranslation } from 'react-i18next';
import useHomeMarket from 'hooks/useHomeMarket';

interface Props {
  patient: Patient;
}

export const ScheduleCTA = ({ patient }: Props) => {
  const { t: translate } = useTranslation();
  const { vios: isViosPatient } = useHomeMarket();

  if (isViosPatient) {
    return (
      <Container>
        <Text>{translate('home_testing.schedule_cta.vios_text')}</Text>
        <Link href="https://viosfertility.com/about-vios-fertility-institute/contact-us/">
          {translate('home_testing.schedule_cta.button_text')}
        </Link>
      </Container>
    );
  }

  return patient.gender === 'male' ? (
    <Container>
      <Text>{translate('home_testing.schedule_cta.male_text')}</Text>
      <Link href="/Book?step=location&appointment_id=318">
        {translate('home_testing.schedule_cta.button_text')}
      </Link>
    </Container>
  ) : (
    <Container>
      <Text>{translate('home_testing.schedule_cta.female_text')}</Text>
      <Link href="/booking-quiz?a=274">{translate('home_testing.schedule_cta.button_text')}</Link>
    </Container>
  );
};
